/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, Output, EventEmitter, HostListener, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import classNames from 'classnames';
/**
 * Switch 开关
 * 开关选择器。
 */
export class Switch {
/**
 * 样式前缀
 */
prefixCls = 'ant-switch';

     checkedText: string;

     uncheckedText: string;
/**
 * 用户CSS样式
 */
class: string;

    /** 大小 */
    // HACK: https://github.com/ant-design/ant-design/issues/5368
    // size=default and size=large are the same
     size: 'small' | 'default' | 'large' = 'default';

     checked = false;

     disabled = false;
/**
 * 改变值事件
 */
change = new EventEmitter<boolean>();
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * 菜单样式
 * @return {?}
 */
get classes(): string {
        return classNames(this.prefixCls, {
            [`${this.prefixCls}-small`]: this.size === 'small',
            [`${this.prefixCls}-checked`]: this.checked,
            [`${this.prefixCls}-disabled`]: this.disabled
        }, this.class);
    }
/**
 * 属性：tabIndex
 * @return {?}
 */
get tabIndex(): number {
        return this.disabled ? -1 : 0;
    }
/**
 * @param {?} checked
 * @return {?}
 */
setChecked(checked: boolean): void {
        if (this.checked !== checked) {
            this.checked = checked;
            this.change.emit(checked);
        }
    }
/**
 * @return {?}
 */
toggle(): void {
        if (this.disabled) {
            return;
        }
        const /** @type {?} */ checked = !this.checked;
        this.setChecked(checked);
    }
/**
 * @param {?} event
 * @return {?}
 */
handleKeyDown(event: KeyboardEvent): void {
        if (event.keyCode === 37) {
            this.setChecked(false);
        }
        if (event.keyCode === 39) {
            this.setChecked(true);
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
handleMouseUp(event: MouseEvent): void {
        this.elementRef.nativeElement.blur();
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-switch',
    template: `
        <span [class]="prefixCls + '-inner'" *ngIf="checked">
            {{checkedText}}<ng-content select="[ant-switch-checked]"></ng-content>
        </span>
        <span [class]="prefixCls + '-inner'" *ngIf="!checked">
            {{uncheckedText}}<ng-content select="[ant-switch-unchecked]"></ng-content>
        </span>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'checkedText': [{ type: Input },],
'uncheckedText': [{ type: Input },],
'class': [{ type: Input },],
'size': [{ type: Input },],
'checked': [{ type: Input },],
'disabled': [{ type: Input },],
'change': [{ type: Output },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'tabIndex': [{ type: HostBinding, args: ['attr.tabIndex', ] },],
'toggle': [{ type: HostListener, args: ['click', ['$event'], ] },],
'handleKeyDown': [{ type: HostListener, args: ['keydown', ['$event'], ] },],
'handleMouseUp': [{ type: HostListener, args: ['mouseup', ['$event'], ] },],
};
}

function Switch_tsickle_Closure_declarations() {
/** @type {?} */
Switch.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Switch.ctorParameters;
/** @type {?} */
Switch.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Switch.prototype.prefixCls;
/** @type {?} */
Switch.prototype.checkedText;
/** @type {?} */
Switch.prototype.uncheckedText;
/**
 * 用户CSS样式
 * @type {?}
 */
Switch.prototype.class;
/** @type {?} */
Switch.prototype.size;
/** @type {?} */
Switch.prototype.checked;
/** @type {?} */
Switch.prototype.disabled;
/**
 * 改变值事件
 * @type {?}
 */
Switch.prototype.change;
/** @type {?} */
Switch.prototype.renderer;
/** @type {?} */
Switch.prototype.elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
